// extracted by mini-css-extract-plugin
export default {"intelligence-highlight":"components-hotel-channel-pricing-tables-cells-minor-channels-table-restrictions-restrictions-row-cell-content-module__intelligence-highlight"};